import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocationStrategy } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { PreviousRouteService } from 'src/app/services/previousRouteService';
import Device from 'src/app/services/device.model';
import { DeviceService } from 'src/app/services/device.service';

@Component({
  selector: 'app-file-download',
  templateUrl: './file-download.component.html',
  styleUrls: ['./file-download.component.scss']
})
export class FileDownloadComponent implements OnInit, OnDestroy {
  public device: Device = new Device();
  public devices: Array<Device> = [];
  public dataAvail: boolean = false;
  public disableDownload: boolean = false;
  public fileDownloadForm: FormGroup;
  public submitted = false;
  public enableDisablePageLoader: boolean = false;
  public submitting: boolean = false;
  public convertedStr: string = '';
  public disptextArr: string[] = [];

  constructor(
    private toastrService: ToastrService,
    public formBuilder: FormBuilder,
    public deviceService: DeviceService,
    private locationStrategy: LocationStrategy,
    private previousRouteService: PreviousRouteService
  ) {
    this.device = new Device();
    this.fileDownloadForm = this.formBuilder.group({
      serial_number: ['', Validators.required],
      fileName: ['', Validators.required],
      filePath: ['', Validators.required],
    });
  }

  public async ngOnInit() {
    try {
      window.scrollTo(0, 0);
      this.enableDisablePageLoader = true;
      this.previousRouteService.setPreviousRoute(this.locationStrategy.path());
      this.devices = await this.deviceService.getAllDevices();
      this.disableDownload = false;
      this.dataAvail = false;
      this.convertedStr = '';
      this.disptextArr = [];
      this.enableDisablePageLoader = false;
    } catch (error) {
      this.toastrService.error(error?.error?.message || error?.message || error);
      this.enableDisablePageLoader = false;
    }
  }

  public ngOnDestroy(): void {
    this.deviceService.cancelOnGoingHttpRequests();
  }

  public get fileDownloadFormValidation() {
    return this.fileDownloadForm.controls;
  }

  public emptyfilenamefilepath() {
    this.device.fileName = '';
    this.device.filePath = '';
    this.fileDownloadForm.patchValue({ fileName: '', filePath: '' });
    this.dataAvail = false;
    this.disableDownload = false;
    this.convertedStr = '';
    this.disptextArr = [];
  }

  public async fileDownload() {
    this.submitted = true;
    if (this.fileDownloadForm.invalid) {
      return;
    }
    const formData = this.fileDownloadForm.value;
    this.device.serial_number = formData.serial_number;
    this.device.fileName = formData.fileName;
    this.device.filePath = formData.filePath;

    try {
      this.submitting = true;
      let deviceRes = await this.deviceService.fileUpload(this.device);
      if (deviceRes && deviceRes.uploaded) {
        this.toastrService.success('File displayed successfully', '', { timeOut: 2000 });
        this.dataAvail = true;
        this.disableDownload = true;
        const resStr = deviceRes.data || '';
        this.b64_to_utf8(resStr);
        this.submitted = false;
      }
      this.submitting = false;
    } catch (error) {
      this.toastrService.error(error?.error?.message || error?.message || error);
      this.submitting = false;
    }
  }

  b64_to_utf8(str: string) {
    try {
      this.convertedStr = decodeURIComponent(escape(window.atob(str)));
      this.disptextArr = this.convertedStr.split('\n');
      return this.convertedStr;
    } catch (e) {
      this.convertedStr = str;
      this.disptextArr = [str];
      return str;
    }
  }

  downloadDeviceDatafile() {
    if (!this.device.serial_number) {
      this.toastrService.warning('Please select device');
      return;
    }
    if (!this.device.fileName) {
      this.toastrService.warning('Please enter file name');
      return;
    }
    if (!this.device.filePath) {
      this.toastrService.warning('Please enter file path');
      return;
    }
    const filename = this.device.fileName || 'deviceData';
    const text = this.convertedStr;
    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
}

